import { AvailableModules, Features } from 'generated/featureDefinitions'
import { ItemIntegrationFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

import { getUpsellImage } from './Images/getUpsellImage'

interface CompensationsUpsellModalProps {
  integration: ItemIntegrationFragment
  onClose: () => void
  featureId?: Features
}

export const CompensationsUpsellModal = ({
  integration,
  onClose,
  featureId,
}: CompensationsUpsellModalProps) => {
  const benefits = [
    i18n.t('marketplace.integrations.upsell_modal.benefits.first', {
      integration_name: integration.name,
    }),
    i18n.t('marketplace.integrations.upsell_modal.benefits.second'),
    i18n.t('marketplace.integrations.upsell_modal.benefits.third'),
    i18n.t('marketplace.integrations.upsell_modal.benefits.fourth'),
  ]

  const contentTitle = i18n.t('marketplace.integrations.upsell_modal.title')
  const modalTitle = i18n.t('sidebar.compensation')

  return (
    <UpsellingKit.ProductModal
      isOpen
      onClose={onClose}
      moduleRequested={AvailableModules.compensations}
      title={contentTitle}
      modalTitle={modalTitle}
      pageSource={`integration-${integration.slug}`}
      requestSource={`integration-${integration.slug}`}
      requestReason={ValidReasons.MissingAddon}
      benefits={benefits}
      image={getUpsellImage(integration.slug)}
      featureRequested={featureId}
    />
  )
}
